import { NotificationType } from './../notification.model';
import { PagedRequestDto } from '../paged-request.model';

export interface NotificationSearchDto extends PagedRequestDto {
  isRead?: boolean;
  notificationType?: NotificationType;
  /** Filter notifications by facility IDs (corporate users accessing facility app) */
  facilities?: string[];
}
